import { WifiOff } from 'lucide-react';

import { useGuardContext } from '@/hooks/useGuardContext';
import { useTranslation } from '@/hooks/useTranslation';

/**
 * Offline Banner — Amber banner below nav header indicating limited functionality.
 * Auto-dismisses when connectivity is restored.
 * Requirements: 12.1, 12.2, 12.3, 12.4
 */
export function OfflineBanner() {
  const { t } = useTranslation();
  const { isOnline } = useGuardContext();

  if (isOnline) return null;

  return (
    <div
      className="flex items-center gap-2 bg-[var(--status-amber)] px-4 py-2 text-sm font-medium text-black"
      role="alert"
    >
      <WifiOff className="size-4 shrink-0" />
      <span>{t('guard.offline.banner')}</span>
    </div>
  );
}
